import { DataItem } from 'scrivito'

import { DataClassName } from '@/Data/const'
import { DocumentProjectRelation } from '@/Data/DocumentProjectRelation/DocumentProjectRelationDataClass'
import { Order } from '@/Data/Order/OrderDataClass'
import { DataScopeOrder } from '@/Data/types'
import { useDataClassIndex } from '@/hooks/useDataClassIndex'
import { getDataItem } from '@/utils/getDataItem'
import { isString } from '@/utils/isString'

interface Args {
  subjectId: string
  search: string
  order: DataScopeOrder
  listSize: number
  subjectRelation?: 'company' | 'document'
}

interface OrderRow {
  id: string
  order: DataItem
  relation?: DataItem
}

export const useOrderTabData = ({
  subjectId,
  search,
  order,
  listSize,
  subjectRelation = 'company',
}: Args) => {
  const isDocument = subjectRelation === 'document'
  const dataClass = isDocument ? DocumentProjectRelation : Order
  const filters = isDocument
    ? {
        document: subjectId,
        projectEntity: DataClassName.ORDER,
        project_search: search,
      }
    : { customer: subjectId }

  const { dataItems, hasMore, loadMore, count } = useDataClassIndex(
    dataClass,
    {
      filters,
      order: [order],
      ...(!isDocument ? { search: search || undefined } : {}),
    },
    listSize,
  )

  const items: OrderRow[] = dataItems.flatMap((item) => {
    if (!isDocument) {
      return [{ id: item.id(), order: item }]
    }

    const projectId = item.get('project') as string
    if (!isString(projectId)) return []
    const { dataItem: order } = getDataItem(Order, projectId)
    if (!order) return []

    return [{ id: order.id(), order, relation: item }]
  })

  return { items, hasMore, loadMore, count }
}
